import { render, staticRenderFns } from "./AvatarOptionsModal.vue?vue&type=template&id=4a27c50a&scoped=true&"
import script from "./AvatarOptionsModal.vue?vue&type=script&lang=js&"
export * from "./AvatarOptionsModal.vue?vue&type=script&lang=js&"
import style0 from "./AvatarOptionsModal.vue?vue&type=style&index=0&id=4a27c50a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a27c50a",
  null
  
)

export default component.exports